import { render, staticRenderFns } from "./BowSlider.vue?vue&type=template&id=bd08cd5c&"
import script from "./BowSlider.vue?vue&type=script&lang=js&"
export * from "./BowSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowIcons: require('/workspace/components/atoms/BowIcons/BowIcons.vue').default})
